import { defineMessages } from 'react-intl';

export const ratingTooltipMessages = defineMessages({
  text: {
    id: 'reviews.rating.info.text',
    defaultMessage:
      'Do počtu hodnocení se započítávají všechna hodnocení produktu, včetně těch bez textového komentáře. Recenze naopak zahrnují pouze hodnocení doplněná o text.',
  },
  drawerTitle: {
    id: 'reviews.rating.info.drawer.title',
    defaultMessage: 'Celkové hodnocení',
  },
});
